<template>
    <div  class="embed-container" style="margin-bottom : 20px;">
        <iframe :src="video_link" width="100%" height="100%" frameborder="0" scrolling="no" allow="autoplay" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen></iframe>
    </div>
</template>

<script>
export default {
    props : ['data','video_id'],
    data(){
        return {
            video_link : this.$attrs.video_link
        }
    }
}
</script>
<!--'https://iframe.dacast.com/live/'-->
